export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_13.f8e1e531.jpg";